import { render, staticRenderFns } from "./TestimonialsSliderItem.vue?vue&type=template&id=4e9abec4"
import script from "./TestimonialsSliderItem.vue?vue&type=script&lang=js"
export * from "./TestimonialsSliderItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports